/* @flow */

import omit from 'lodash/omit';

import decorator from 'lib/lang/decorator';
import {ValueFieldData} from 'lib/form/value-field-data';
// import computed from 'lib/mobx/computed';

import withUsersAutocomplete from './with-users-autocomplete';

export default decorator(({
    searchFieldName = 'username', fieldName = 'users',
} = {}) => (Class: typeof Form) => {

    class UsersForm extends withUsersAutocomplete({searchFieldName, fieldName})(Class) {
        constructor(options) {
            const {userStore} = options;

            super(options);

            const next = this.handleSubmit;
            this.handleSubmit = ({form, data, ...rest}) => {
                let promise;

                const users = data[fieldName];
                const username = data[searchFieldName];

                if (!username) {
                    promise = Promise.resolve(users);
                } else {
                    promise = userStore
                        .searchExact({username})
                        .then((user: User) => {
                            form.field.get(fieldName).data.push(
                                new ValueFieldData({value: user}),
                            );
                            form.field.get(searchFieldName).data.setValue({
                                value: '',
                            });

                            return [...users, user];
                        });
                }

                return promise.then(result => next({
                    data: {
                        ...omit(data, [searchFieldName]),
                        [fieldName]: result,
                    },
                    form,
                    ...rest,
                }));
            };
        }
    }

    return UsersForm;
});

